import { render, staticRenderFns } from "./ImportWorkers.vue?vue&type=template&id=5d1e2bf6&"
import script from "./ImportWorkers.vue?vue&type=script&lang=js&"
export * from "./ImportWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports